import { runDemo } from "../shared/demoRunner";
import { createSpaceshipScene } from "./scene";

runDemo({ createScene: createSpaceshipScene });
